module.exports = __webpack_public_path__ + "static/Action-Shots-1-6b7ac2c1eafcc1c97fcb3157bb269a24.jpg";